export const MAX_TREE_LEVEL_LM = 7;

export enum ETreeNodeMode {
    selectDlg = 'selectDlg',
}
